// https://github.com/lancedikson/bowser
import Bowser from 'bowser';

let userAgent =
  navigator.userAgent ||
  window.navigator.userAgent ||
  navigator.vendor ||
  window.opera;

let parser = Bowser.getParser(userAgent);
if (!window.moo) {
  window.moo = {};
}
window.moo.ua = {
  browser: parser.parsedResult.browser,
  // cpu: parser.parsedResult.,
  device: parser.parsedResult.platform,
  engine: parser.parsedResult.engine,
  os: parser.parsedResult.os,
  text: userAgent,
};
parser = null;
